// extracted by mini-css-extract-plugin
module.exports = {"header":"nav_header__2Zyzi","sticky":"nav_sticky__K56vi","logo":"nav_logo__2Qeuc","mb-btn":"nav_mb-btn__18a_9"};